const matchesSearch = (value: string, input: string): boolean => {
  return value.trim().toLowerCase().includes(input.trim().toLowerCase());
};

export default matchesSearch;
